import { loadPropertiesFromElement, tryGetBlockElement } from "./element-properties-loader";

function replaceNode(node: HTMLElement, updatedNode: HTMLElement) {
    if (updatedNode) {
        node.innerHTML = updatedNode.innerHTML;

        if (node.tagName === updatedNode.tagName) {
            const updatedAttributes = updatedNode.attributes;
            for (let i = 0; i < updatedAttributes.length; i++) {
                const updatedAttribute = updatedAttributes[i];
                node.setAttribute(updatedAttribute.name, updatedAttribute.value);
            }

            // make sure to clean up attributes which no longer exist on the updated DOM node
            const attributes = node.attributes;
            for (let i = 0; i < attributes.length; i++) {
                const attribute = attributes[i];
                if (!updatedNode.getAttribute(attribute.name)) {
                    node.removeAttribute(attribute.name);
                }
            }
        }
    } else {
        node.remove();
    }
}

(function () {
    // Client side property renderer for NCD. Request page html from the delivery site and partial refresh the property DOM.

    function updateHtmlDom(newHtmlContent: any, updatedProperties: any, saveContentLink: string) {
        const page = document.createElement("html");
        page.innerHTML = newHtmlContent;

        const updatedBlockNode = tryGetBlockElement(page, saveContentLink);
        if (updatedBlockNode) {
            const existingBlockNode = tryGetBlockElement(document, saveContentLink);
            if (existingBlockNode) {
                replaceNode(existingBlockNode, updatedBlockNode);
                return;
            }
        }

        updatedProperties.forEach(function (property: any) {
            if (!property.successful) {
                return;
            }

            const updatedNode = loadPropertiesFromElement(page, property.name)[0];
            loadPropertiesFromElement(document, property.name).forEach(function (node) {
                // skip rendering properties that set `data-epi-edit` or has `data-epi-property-render`=="none"
                // this will typically happen if the client wants the OPE to work but wants to take care of rendering on their own (i.e. React
                if (node.getAttribute("data-epi-edit") || node.getAttribute("data-epi-property-render") === "none") {
                    return;
                }
                // skip rendering if partial renderer is requested
                if (node.getAttribute("data-epi-property-render") === "partial" && !property.forceRender) {
                    return;
                }
                replaceNode(node, updatedNode);
            });
        });
    }

    function getUpdatedPageContentAsync(contentLink: string) {
        // Replace url with updated ContentLink
        const url = location.href.replace(/,,[\d_]+/, ",," + contentLink);
        return fetch(url, { cache: "no-cache" }).then(function (response) {
            if (response.ok && !response.redirected) {
                return response.text();
            } else {
                throw new Error(response.statusText);
            }
        });
    }

    window.addEventListener("optimizely:cms:contentSaved", function (event: any) {
        const message = event.detail;

        if (!message.properties || !Array.isArray(message.properties)) {
            return;
        }

        getUpdatedPageContentAsync(message.contentLink)
            .then(function (data) {
                updateHtmlDom(data, message.properties, message.contentLink);
            })
            .catch(function (error) {
                console.error("An error has occurred during fetch operation.", error);
            });
    });
})();
